(() => {
  const requests = new Map();
  const waitingClicks = new WeakSet();
  const getTarget = (node) => node instanceof Element ? node.closest("[data-interaction-css]") : null;
  const loadStylesheet = (target) => {
    const href = target.getAttribute("data-interaction-css");
    let request = requests.get(href);
    if (request) return request;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    request = { status: "loading", promise: null };
    request.promise = new Promise((resolve) => {
      link.onload = () => {
        request.status = "loaded";
        resolve(true);
      };
      link.onerror = () => {
        request.status = "failed";
        resolve(false);
      };
    });
    requests.set(href, request);
    document.head.append(link);
    return request;
  };
  document.addEventListener("pointerover", (event) => {
    const target = getTarget(event.target);
    if (target && target.getAttribute("data-interaction-css-preload") !== "false") {
      void loadStylesheet(target).promise;
    }
  }, true);
  document.addEventListener("pointerdown", (event) => {
    const target = getTarget(event.target);
    if (target) void loadStylesheet(target).promise;
  }, true);
  document.addEventListener("focusin", (event) => {
    const target = getTarget(event.target);
    if (target) void loadStylesheet(target).promise;
  }, true);
  document.addEventListener("click", (event) => {
    const target = getTarget(event.target);
    if (!target) return;
    const href = target.getAttribute("data-interaction-css");
    const request = requests.get(href);
    if (request && (request.status === "loaded" || request.status === "failed")) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (waitingClicks.has(target)) return;
    waitingClicks.add(target);
    void loadStylesheet(target).promise.then(() => {
      waitingClicks.delete(target);
      target.click();
    });
  }, true);
})();
